import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const NewJobPage = ({ newJob }: { newJob: boolean }) => {
  const { id } = useParams<{ id?: string }>();
  const title = newJob ? 'Create Job' : 'Edit Job';
  return (
    <PageProvider key={id ?? 'new'}>
      <Helmet>
        <title>{title} - AutoScript</title>
      </Helmet>
      <Header title={title} />

      <Content />
    </PageProvider>
  );
};
